import { Navigate, useSearchParams } from "react-router-dom";

/** Legacy route — opens Quiz Manager on the Questions tab. */
const QmsQuestionBank = () => {
  const [searchParams] = useSearchParams();
  const next = new URLSearchParams(searchParams);
  if (!next.get("tab")) {
    next.set("tab", "questions");
  }
  const query = next.toString();
  return (
    <Navigate to={`/qms/quizzes${query ? `?${query}` : "?tab=questions"}`} replace />
  );
};

export default QmsQuestionBank;
